/** Public transaction references only. No login or scanner credentials belong here. */
export interface ClaimAttempts { current: string; previous: string[] }
export interface HistoryPage { limit: number; hasMore: boolean; nextCursor: string | null; total: number | null }
export function transactionHash(value: unknown): string | null {
  return typeof value === 'string' && /^0x[0-9a-f]{64}$/i.test(value.trim()) ? value.trim().toLowerCase() : null;
}
export function claimStorageKey(chainId: number, vault: string | null | undefined, wallet: string, receiptId: string): string {
  return `receipt.claim.v2.${chainId}.${(vault || 'unconfigured').toLowerCase()}.${wallet.toLowerCase()}.${receiptId}`;
}
export function readClaimAttempts(storage: Pick<Storage, 'getItem'>, key: string): ClaimAttempts | null {
  try {
    const saved = JSON.parse(storage.getItem(key) || 'null');
    const current = transactionHash(saved?.current);
    if (!current) return null;
    const previous = Array.isArray(saved.previous) ? [...new Set(saved.previous.map(transactionHash).filter((hash: string | null): hash is string => !!hash && hash !== current))].slice(0, 4) as string[] : [];
    return { current, previous };
  } catch { return null; }
}
export function recordClaimAttempt(previous: ClaimAttempts | null, value: string): ClaimAttempts {
  const current = transactionHash(value);
  if (!current) throw new Error('Enter the complete 66-character transaction hash from your wallet or block explorer.');
  return { current, previous: [...new Set([...(previous ? [previous.current, ...previous.previous] : [])])].filter(hash => hash !== current).slice(0, 4) };
}
export function historyPage(value: any, count: number): HistoryPage | null {
  if (!value || typeof value !== 'object') return null;
  const limit = Number.isInteger(value.limit) && value.limit > 0 ? value.limit : count;
  const nextCursor = typeof value.nextCursor === 'string' && value.nextCursor.length > 0 && value.nextCursor.length <= 2048 ? value.nextCursor : null;
  const total = Number.isSafeInteger(value.total) && value.total >= 0 ? value.total : null;
  return { limit, hasMore: value.hasMore === true && !!nextCursor, nextCursor, total };
}
export function mergeHistory<T extends { id: string }>(existing: T[], incoming: T[]): T[] {
  const incomingById = new Map(incoming.map(item => [item.id, item]));
  const result = existing.map(item => incomingById.get(item.id) || item);
  const known = new Set(result.map(item => item.id));
  for (const item of incoming) if (!known.has(item.id)) { result.push(item); known.add(item.id); }
  return result;
}
export function validScanCapability(value: string): boolean { return /^[a-f0-9]{64}$/i.test(value); }
